import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import sanitizeItemContextMetadata from 'analytics/snowplow/eventContexts/item/sanitizeItemContextMetadata'

function getMerchandiseCheckoutItem(state: App.State, item: App.Checkout.MerchandiseItem, isMultiCart?: boolean) {
  const offerId = item.advertId
  const merchandise = state.merchandise.merchandise[offerId] as App.MerchandiseOffer | undefined

  return comluxgroup.createItem_1_1_1({
    offerId: offerId,
    categoryId: 'shop',
    productId: 'merchandise',
    offerLeadPrice: merchandise?.leadVariant.price,
    price: merchandise?.leadVariant.price,
    currency: state.geo.currentCurrency,
    metadata: sanitizeItemContextMetadata({
      isMultiCart,
    }),
  })
}

export default getMerchandiseCheckoutItem
